<script lang="ts">
	import type { PostSummary } from '$lib/types';

	export let older: PostSummary | null = null;
	export let newer: PostSummary | null = null;
</script>

<nav class="article-end" aria-label="Adjacent notes">
	<a class="end-index" href="/#archive">Back to the archive</a>

	{#if older || newer}
		<div class="end-adjacent">
			{#if older}
				<a class="end-link end-older" href="/posts/{older.slug}" rel="prev">
					<span class="end-label">Older</span>
					<span class="end-title">{older.title}</span>
				</a>
			{:else}
				<span class="end-link end-placeholder" aria-hidden="true"></span>
			{/if}

			{#if newer}
				<a class="end-link end-newer" href="/posts/{newer.slug}" rel="next">
					<span class="end-label">Newer</span>
					<span class="end-title">{newer.title}</span>
				</a>
			{:else}
				<span class="end-link end-placeholder" aria-hidden="true"></span>
			{/if}
		</div>
	{/if}
</nav>
